import FormElementRenderer from './form.el';
import UICommon from './common';
import * as CONST from '../const';
const LIST = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
class FormElementListFacesRenderer extends FormElementRenderer {
    render(option, cont, index) {
        let list = '';
        const price = UICommon.formatPrice(this.owner.getPropertyPrice(option.optionName));
        const hidden = this.getHiddenClass(option), inDigital = this.checkIfOptionIsDigital(option) ? 'digital' : '', inRolled = this.checkIfOptionIsRolled(option) ? 'rolled' : '', tooltip = this.returnTooltipTrigger();
        LIST.forEach((count, index) => {
            const selected = (((option.default === `${count}`) || (typeof option.default === 'undefined' && index === 0))) ? 'selected="selected" ' : '';
            list += `<option ${selected} value="${count}">${count}</option>`;
        });
        const el = document.createElement('div');
        [CONST.OPT_CLASS_OPTION_NORMAL, inDigital, inRolled, hidden].forEach(name => name && el.classList.add(name));
        el.id = `option_${option.optionName}`;
        el.innerHTML = `
       <label class="align-content-left" for="select_${this.getElementId(option)}"><span>${option.title}</span> ${tooltip}</label>
       <div class="input-select">
        <select data-option-id="${option.id}" id="select_${this.getElementId(option)}" name="select_${this.getElementId(option)}" tabindex="${index}">${list}</select>
       </div><span class="price">${price}</span>`;
        this.appendFacesListEl(el, cont, option);
        this.bindTooltip(option);
    }
    updateFromSummary(option, summary) {
        const el = document.querySelector(`#option_${option.optionName} select`);
        const options = el.querySelectorAll('option');
        Array.from(options).forEach((optionEl, index) => {
            if (parseInt(optionEl.value) === summary.facesCount) {
                el.selectedIndex = index;
            }
        });
    }
}
export default FormElementListFacesRenderer;
